export default __webpack_public_path__ + "static/media/gm-power-transfer-active.99f6a658.svg";